import React, { useEffect, useReducer, useRef, useState } from 'react';
import { CriticalPath, Edit, ExcelExport, Filter, GanttComponent, Inject, IQueryTaskbarInfoEventArgs, Selection as GanttSelection, Sort, Toolbar, ColumnsDirective, ColumnDirective, EditMode, Resize, ContextMenuItem, ContextMenu } from "@syncfusion/ej2-react-gantt";
import delay from "../../Shared/Functions/Delay";
import { DeleteTodosRequest, TodoGanttDTO, TodoState, UpdateTodoGanttRequest, VovClient } from '../../../ApiOld/ApiServerVov';
import { t, use } from 'i18next';
import InitSfGanttLocale from '../../../Localization/SfGanttLanguageInitializer';
//import './TodoGanttOld.css';
import { setCulture } from '@syncfusion/ej2-base';
import { useParams } from 'react-router';
import { useApi } from '../../../ApiOld/Api/useApi';
import TodoGanttToolbar from './TodoGanttToolbar';
InitSfGanttLocale('cs');

export interface TodoGanttPropsOld {
    tasksGantt: TodoGanttDTO[] | undefined;
    refresh: () => void;
}
export default function TodoGanttOld(props: TodoGanttPropsOld) {
    const { tasksGantt, refresh } = props;
    const params = useParams();

    const [tasksLocal, setTasksLocal] = useState<TodoGanttDTO[]>([]);

    useEffect(() => {
        if (tasksGantt) {
            setTasksLocal(tasksGantt);
            if (ganttInstance.current) {

                delay(300).then(() => {
                    ganttInstance.current?.refresh();
                });
            }
        }
    }, [tasksGantt]);

    const { authorizedApi } = useApi(VovClient);
    const ganttEditSettings = {

        allowAdding: true,
        allowEditing: false,
        allowDeleting: true,
        allowTaskbarEditing: true,
        showDeleteConfirmDialog: true,
        dateFormat: 'dd.M.yyyy'
    };
    function ganttToolbarClick(e: any) {
        /* if (e.item.properties.text == "Edit") {
            setIsEdit(true);
        } */
        if (e.item.id.toString().endsWith('excelexport') && ganttInstance !== undefined) {
            ganttInstance.current!.excelExport();
        }
        else if (e.item.id === 'GanttExport_csvexport' && ganttInstance !== undefined) {
            ganttInstance.current!.csvExport();
        }

    }
    function queryTaskbarInfo(args: IQueryTaskbarInfoEventArgs | undefined) {
        if (args !== undefined) {
            // console.log("args neni und", args);
            if ((args.data.taskData instanceof TodoGanttDTO) && (args.data.taskData as TodoGanttDTO).state === TodoState.RESOLVED) {
                // console.log("nastavuji");
                args.taskbarBgColor = "#91D05D";
                args.taskbarBorderColor = "#33B37B";
                args.progressBarBgColor = "#33B37B";
            }
            else if ((args.data.taskData instanceof TodoGanttDTO) && (args.data.taskData as TodoGanttDTO).state === TodoState.ACTIVE) {
                args.taskbarBgColor = "#f5e342";
                args.taskbarBorderColor = "#fccf03";
                args.progressBarBgColor = "#FFC600";
            }
        }
    }

    const taskFields = {
        id: 'id',
        name: 'name',
        startDate: 'datetimeStart',
        endDate: 'datetimeEnd',
        duration: 'duration',
        progress: 'progress',
        dependency: 'predecessor',
        child: 'subtasks',
    };
    const ref = useRef<HTMLDivElement>(null);
    //mměli by tu být jiný data
    /* let toolbarGanttOptions = ['ExcelExport', 'Add', 'Edit', 'Update', 'Delete', 'Cancel' , 'ExpandAll', 'CollapseAll' , 'Search']; */
    const ganttInstance = useRef<GanttComponent>(null);

    React.useEffect(() => {
        setCulture(params['lang']!);
        //ganttInstance.current!.height = window.innerHeight - ref.current!.parentElement!.offsetHeight - 98;
        //ganttInstance.current!.width = ref.current!.parentElement!.offsetWidth - 49;
        ganttInstance.current!.splitterSettings = { position: '40%' };
        /* delay(860).then(() => {
            ganttInstance.current!.refresh();
        });
 */
    }, []);
    /* React.useEffect(() => {

        if (ganttInstance.current) {

            delay(200).then(() => {
                ganttInstance.current?.refresh();
            });
        }
    }, [tasksLocal]); */

    function handleActionBegin(e: any) {
        if (e.requestType == 'beforeOpenEditDialog' /* && !isEdit */)
            e.cancel = true;

        const taskData = e.rowData;
        console.log('taskData', e, taskData);
        if (taskData && taskData.isBuilding) {
            console.log('cancelling ....');
            e.cancel = true;

        }
    }

    function handleActionComplete(e) {
        console.log('request type completed:', e.requestType);
        if (e.requestType === 'save') {
            // This is triggered after editing or adding a task
            const updatedTask = e.data; // The updated task data

            if (updatedTask && updatedTask.taskData && updatedTask.taskData.isBuilding) {
                console.log('Reverting changes for parent task:', updatedTask.name);
                ganttInstance.current?.refresh(); // Refresh the Gantt chart to undo changes
                return;
            }
            console.log('update task', updatedTask);
            authorizedApi.updateTodoGantt(new UpdateTodoGanttRequest({ data: updatedTask.taskData })).then(() => {
                console.log('updated');
            });
            // Send the updated task to your server
        } else if (e.requestType === 'delete') {
            // This is triggered after deleting a task
            const deletedTask = e.data;
            if (deletedTask && deletedTask.taskData && deletedTask.taskData.isBuilding) {
                console.log('Reverting changes for parent task:', deletedTask.name);
                ganttInstance.current?.refresh(); // Refresh the Gantt chart to undo changes
                return;
            }

            authorizedApi.deleteTodos(new DeleteTodosRequest({ selectedTodos: deletedTask.map(p => p.id) })).then(() => {
                console.log('deleted');
                refresh();
            });
            // Send the deleted task info to your server
        }
    }

    const contextMenuItems: ContextMenuItem[] = ['DeleteDependency'];

    return (
        <div ref={ref} style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 234px)' }}>
            <TodoGanttToolbar gantt={ganttInstance} />
            <div style={{ flex: 1, overflow: 'auto' }}>
                <GanttComponent
                    enableContextMenu={true} contextMenuItems={contextMenuItems}
                    ref={ganttInstance}
                    actionBegin={handleActionBegin}
                    actionComplete={handleActionComplete}
                    editSettings={ganttEditSettings}
                    allowSelection={true}
                    allowExcelExport={true}
                    toolbar={undefined}
                    toolbarClick={ganttToolbarClick}
                    allowFiltering={true}
                    allowSorting={true}
                    enableCriticalPath={false}
                    timelineSettings={{ weekStartDay: 1 }}
                    includeWeekend
                    dateFormat='dd.M.yyyy'
                    queryTaskbarInfo={queryTaskbarInfo}
                    filterSettings={{ ignoreAccent: true }}
                    dataSource={tasksLocal}
                    taskFields={taskFields}
                    allowResizing={true}
                    height={'100%'}
                >
                    <ColumnsDirective>
                        <ColumnDirective field='id' width='100' headerText={t('gantt.id')} isPrimaryKey />
                        <ColumnDirective field='name' headerText={t('gantt.task')} />
                        <ColumnDirective field='datetimeStart' headerText={t('todo.startDate')} format='dd.M.yyyy' />
                        <ColumnDirective field='datetimeEnd' headerText={t('todo.endDate')} format='dd.M.yyyy' />
                        <ColumnDirective field='duration' headerText={t('todo.duration')} />
                        <ColumnDirective field='progress' headerText={t('todo.progress')} />
                    </ColumnsDirective>
                    <Inject services={[GanttSelection, CriticalPath, Filter, Sort, ExcelExport, Toolbar, Edit, Resize, ContextMenu]} />
                </GanttComponent>
            </div>
        </div>
    );
}